import { Link } from 'react-router-dom';
import { downloadLegalDocument } from '../legal/legalDocuments';
import '../css/Legal.css';

export default function LegalAcceptanceReceipt({ receipt }) {
    if (!receipt) return <section className="ef-contract-receipt" aria-labelledby="contract-receipt-title">
        <h2 id="contract-receipt-title">Documenti del tuo account</h2>
        <p>Non risulta una ricevuta di accettazione per questo account. Puoi consultare le <Link to="/condizioni-agenzie">condizioni attuali</Link> o scrivere a <a href="mailto:info@easy-funeral.it">info@easy-funeral.it</a> per chiarimenti.</p>
    </section>;

    const acceptedAt = new Date(receipt.acceptedAt);
    const formattedDate = Number.isNaN(acceptedAt.getTime()) ? receipt.acceptedAt
        : acceptedAt.toLocaleString('it-IT', { dateStyle: 'long', timeStyle: 'short', timeZone: 'Europe/Rome' });

    return <section className="ef-contract-receipt" aria-labelledby="contract-receipt-title">
        <h2 id="contract-receipt-title">La tua ricevuta di iscrizione</h2>
        <p>Accettazione registrata il <time dateTime={receipt.acceptedAt}>{formattedDate}</time> (ora italiana).</p>
        <p>Condizioni di servizio: versione {receipt.termsVersion}. Informativa privacy: versione {receipt.privacyVersion}.</p>
        <div className="ef-legal-actions">
            {receipt.termsDocument && <button type="button" onClick={() => downloadLegalDocument(receipt.termsDocument, 'condizioni-agenzie')}>Scarica le condizioni accettate</button>}
            {receipt.privacyDocument && <button type="button" onClick={() => downloadLegalDocument(receipt.privacyDocument, 'privacy')}>Scarica l’informativa ricevuta</button>}
        </div>
        <p>Per una copia dei dati, la chiusura dell’account o altre richieste: <a href="mailto:info@easy-funeral.it">info@easy-funeral.it</a>.</p>
    </section>;
}
